export default __webpack_public_path__ + "static/media/infoicon.cf833cc6.svg";